module.exports = __webpack_public_path__ + "band_12_daughter.3f9875da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_12_daughter.png
// module id = 07M8
// module chunks = 0